/* Copyright 2024 Marimo. All rights reserved. */
import { Handler } from "vega-tooltip";

// Create a tooltip handler that supports HTML content (including images)
export const tooltipHandler = new Handler();
